import React from 'react'

const Footer = () => {
  return (
    <div className='p-9 bg-violet-800 text-gray-200 text-center'>
      <p>@ All Rights Reserved 2022 yossra bahloul</p>
    </div>
  )
}

export default Footer
